import type { FC } from 'react';
import { toast } from 'react-toastify';
import { DocumentStatusUpdate } from '@ContractBuilder/components/Notifications';
import { useEntityStore } from '@ContractBuilder/store';
import { useDrawerStore } from '@ContractBuilder/store/drawer.store';
import type { PublishingOptionType } from '@ContractBuilder/types';
import type { ResourceState } from '@domain/schemas/contract.schema';

import { ContractTools } from '../views/ContractTools';

interface ContractToolsControllerProps {
  publishingOptions: PublishingOptionType[];
}

export const ContractToolsController: FC<ContractToolsControllerProps> = ({ publishingOptions }) => {
  const closeDrawer = useDrawerStore(({ closeDrawer }) => closeDrawer);
  const { isLoading, submission, updateResourceData } = useEntityStore(
    ({ isLoading, submission, updateResourceData }) => ({
      isLoading,
      submission,
      updateResourceData,
    }),
  );

  const handleStatusUpdate = async (status?: ResourceState, shouldBypassDatapointValidation?: boolean) => {
    await updateResourceData({ status }, undefined, shouldBypassDatapointValidation);
    if (status) {
      toast(<DocumentStatusUpdate status={status} />, { type: 'success' });
      closeDrawer();
    }
  };

  if (!submission) {
    return null;
  }

  return (
    <ContractTools
      isLoading={isLoading}
      onStatusUpdate={handleStatusUpdate}
      publishingOptions={publishingOptions}
      submission={submission}
    />
  );
};
